// extracted by mini-css-extract-plugin
export default {"wrapper":"documents_wrapper__PU1r3","documents":"documents_documents__9rLAW","document":"documents_document__4V49s"};